export class GetSteamInventory {
  public static readonly type = '[p2p] Get Steam Inventory';
  // constructor(public key?: string) {}
}
export class GetSteamStatus {
  public static readonly type = '[p2p] Get Steam Status';

}